import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  style: {"color":"red"},
  class: "mt-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center mb-3" }, "Импорт данных", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "Введите пароль для импорта", -1)

import { onBeforeUnmount, ref, Ref } from 'vue'
import { ToolsService, ImportStatus, ExportMetaInfo } from '@prodcard/core'
import { createCtx, handleError } from '../../../helpers'

interface FileWithPath extends File {
  path: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportTab',
  props: {
    toolsService: {}
  },
  setup(__props: any) {

const props = __props;



const importStatus: Ref<ImportStatus | undefined> = ref(props.toolsService.importStatus.value)
const importStatusWatcher = props.toolsService.importStatus.subscribe(status => {
  if (status?.errorMessage) {
    importPassword.value = undefined
    errorMessage.value = status.errorMessage
  }
  importStatus.value = status
})

const metaLoading = ref(false)
const showMetaDialog = ref(false)
const showPasswordDialog = ref(false)
const metaInfo: Ref<ExportMetaInfo | undefined> = ref(undefined)
const path = ref()
const importPassword = ref()
const errorMessage = ref(importStatus?.value?.errorMessage)

// ts почему-то не знает, что у File есть path
function selectFile(contentType: string): Promise<string | undefined> {
  return new Promise(resolve => {
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = contentType

    const onFinish = () => {
      if (!input.files || input.files.length === 0) resolve(undefined)
      else resolve((input.files.item(0) as FileWithPath | undefined)?.path)
    }

    input.onchange = onFinish
    input.onblur = onFinish
    input.oncancel = onFinish
    input.click()
  })
}

const selectFileToImport = async () => {
  errorMessage.value = ''
  const file = await selectFile('zip, application/zip')
  if (!file) {
    return
  }
  handleError(async () => {
    path.value = file
    const response = await props.toolsService.parseMeta(createCtx(), path.value)
    if (response) {
      metaInfo.value = response
      showMetaDialog.value = true
    } else {
      errorMessage.value = 'Файл загрузки некорректен'
    }
  }, metaLoading)
}

const importData = async () => {
  handleError(async () => {
    showPasswordDialog.value = false
    await props.toolsService.importData(createCtx(), importPassword.value, path.value)
  })
}

const cancel = () => {
  showPasswordDialog.value = false
  showMetaDialog.value = false
}

onBeforeUnmount(() => {
  props.toolsService.importStatus?.unsubscribe(importStatusWatcher)
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_btn, {
      onClick: selectFileToImport,
      class: "mt-3",
      disabled: importStatus.value?.isImporting,
      loading: importStatus.value?.isImporting
    }, {
      default: _withCtx(() => [
        _createTextVNode("Загрузить данные")
      ]),
      _: 1
    }, 8, ["disabled", "loading"]),
    _createElementVNode("p", _hoisted_1, _toDisplayString(errorMessage.value), 1),
    (metaInfo.value)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 0,
          modelValue: showMetaDialog.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showMetaDialog).value = $event)),
          width: "500",
          persistent: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "pa-5 bg-white" }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createElementVNode("p", null, "Дата экспорта: " + _toDisplayString(new Date(metaInfo.value.exportedAt).toLocaleDateString()), 1),
                (metaInfo.value.exportSettings.range)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Период времени данных: " + _toDisplayString(`${new Date(metaInfo.value.exportSettings.range[0]).toLocaleDateString()} -
           ${new Date(metaInfo.value.exportSettings.range[1]).toLocaleDateString()}`), 1))
                  : _createCommentVNode("", true),
                (metaInfo.value.moName)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Муниципальное образование: " + _toDisplayString(metaInfo.value.moName), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_card_actions, { class: "justify-end mt-3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, { onClick: cancel }, {
                      default: _withCtx(() => [
                        _createTextVNode("Отмена")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      onClick: _cache[0] || (_cache[0] = 
            () => {
              showMetaDialog.value = false
              showPasswordDialog.value = true
            }
          ),
                      variant: 'elevated'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Далее")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: showPasswordDialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showPasswordDialog).value = $event)),
      width: "500",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pa-5 bg-white" }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createVNode(_component_v_text_field, {
              modelValue: importPassword.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((importPassword).value = $event)),
              class: "mt-3"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_v_card_actions, { class: "justify-end mt-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, { onClick: cancel }, {
                  default: _withCtx(() => [
                    _createTextVNode("Отмена")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  disabled: !importPassword.value,
                  onClick: importData,
                  variant: 'elevated'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Далее")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})